var map = {
	"./arrays.md": 1240,
	"./avl.md": 86628,
	"./bellmanford.md": 98611,
	"./binarysearch.md": 57623,
	"./binarysearchtree.md": 82232,
	"./breadthfirstsearch.md": 64213,
	"./bubblesort.md": 93967,
	"./depthfirstsearch.md": 7445,
	"./dijkstras.md": 15035,
	"./fibonaccisequence.md": 83908,
	"./floodfill.md": 68698,
	"./hashtable.md": 45097,
	"./hashtablelinkedlist.md": 31682,
	"./hashtablequadratic.md": 41866,
	"./heaps.md": 16020,
	"./heapsort.md": 71394,
	"./huffmancodingtree.md": 56938,
	"./inorder.md": 27220,
	"./insertionsort.md": 45602,
	"./kruskals.md": 16735,
	"./linearsearch.md": 21039,
	"./mergesort.md": 91134,
	"./nqueens.md": 96087,
	"./postorder.md": 98004,
	"./preorder.md": 42338,
	"./prims.md": 48706,
	"./quicksort.md": 27074,
	"./selectionsort.md": 27088,
	"./singlylinkedlist.md": 38969,
	"./test.md": 41390,
	"./towersofhanoi.md": 28454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30921;